import { PercentBoxOutlineIcon } from './PercentBoxOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 4B5165F6-736B-44F7-961C-420A1F2EEFE7
 * name percent-box-outline
 * version: 6.6.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/percent-box-outline.svg
 * tags
 * - Math 
 * - Shopping 
 */
export const SaleBoxOutlineIcon = PercentBoxOutlineIcon;
export default SaleBoxOutlineIcon